// POSTs to the backend and hands each server-sent event to onEvent(event, data)
// as it arrives — the admin Pilot answers this way. A stream is read with
// fetch, which the shared axios instance can't do, so it sends the session
// cookie itself and repeats the two auth redirects axios's interceptor makes.
export const postEventStream = async (
  path,
  body,
  { onEvent, signal, failureMessage },
) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
    signal,
  });
  if (response.status === 401) {
    window.location.href = "/login";
    throw new Error("Session expired");
  }
  if (!response.ok || !response.body) {
    const answer = await response.json().catch(() => null);
    if (response.status === 403 && answer?.code === "MFA_REQUIRED") {
      window.location.href = "/mfa-setup";
      throw new Error("Two-factor setup required");
    }
    throw new Error(answer?.message || failureMessage);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) return;
    buffer += decoder.decode(value, { stream: true });
    let boundary;
    while ((boundary = buffer.indexOf("\n\n")) !== -1) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      const event = frame.match(/^event: (.+)$/m)?.[1];
      const data = frame.match(/^data: (.+)$/m)?.[1];
      if (event && data) onEvent(event, JSON.parse(data));
    }
  }
};
